import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./BundlePackage.css";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import DiscountIcon from "@mui/icons-material/Discount";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import RamenDiningIcon from "@mui/icons-material/RamenDining";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useUserAuth } from "../../context/UserAuthContext";
import axios from "axios";
import placeholder from "../../../public/placeholder.jpg";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
const BundlePackage = () => {
  const { user, language, token, currency } = useUserAuth();
  console.log("currency",currency)
  const merchant_id = user.uid;
  const [packageList, setPackageList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [city, setCity] = useState();
  const [venue, setVenue] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packageImages, setPackageImages] = useState([]);
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/packages/merchant_wise/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPackageList(res?.data?.data);
    } catch (err) {
      console.log("package getting error", err.message);
    }
  };
  const getVenue = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/users/venue`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = res?.data?.data;
      setVenue(data);
    } catch (error) {
      console.log(`Error ${error} `);
    }
  };


  const cityList = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/cities`);
      setCity(res?.data.data);
    } catch (error) {
      console.log(`Error ${error} `);
    }
  };
  useEffect(() => {
    if (!merchant_id) return;
    getVenue();
    cityList();
    getSingleDocumentHandler();
  }, [merchant_id, token]);

  const deletePackage = async (id) => {
    const choice = window.confirm("Are you sure want to delete?");
    if (choice) {
      try {
        await axios.delete(`${base_url}/api/v1/packages/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: {
            merchant_id: merchant_id,
          },
        });
        toast.success("Package deleted Successfully");
        getSingleDocumentHandler();
      } catch (err) {
        console.log(err);
      }
    } else {
      return;
    }
  };

  const openPriorityModal = async (packageId) => {
    setSelectedPackage(packageId);
    setShowModal(true);
    try {
      const res = await axios.get(`${base_url}/api/v1/packages/${packageId}/images`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPackageImages(res?.data?.data?.data);
    } catch (error) {
      console.log("Error fetching package images:", error);
    }
  };
  const handlePriorityChange = async (selectedImageId) => {
    try {
      const updatedImages = packageImages.map((img) => ({
        ...img,
        is_primary: img.id === selectedImageId,
      }));
      setPackageImages(updatedImages);
      await axios.put(
        `${base_url}/api/v1/packages/${selectedImageId}/set-primary`,
        { packageId: selectedPackage },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Primary image set successfully!");
    } catch (error) {
      console.error("Error setting primary image:", error);
      toast.error("Failed to set primary image. Please try again.");
    }
  };

  return (
    <>
      <div className="page-wrapper bundle">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div
                  className="card-header d-flex justify-content-between align-items-center text-white"
                  style={{ backgroundColor: "#085f9a" }}
                >
                  <div className="">
                    <input
                      type="text"
                      placeholder="Search Package..."
                      className="form-control"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                      }}
                    />
                  </div>
                  <div className="">
                    <Link
                      to="/dashboard/create-package"
                      className="btn text-dark "
                      style={{ backgroundColor: "#fff" }}
                    >
                      {language === "en" ? `  Add Package` : ` पैकेज बनाएँ `}
                    </Link>
                  </div>
                </div>
                <div className="row p-3">
                  {packageList
                    ?.filter((curEle) =>
                      curEle.package_name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                    )
                    .map((cur, index) => {
                      return (
                        <div className="col-12 col-md-6 col-lg-4 col-xl-4 my-2" key={index}>
                          <div className="package-card">
                            <div className="card-header border-0 p-2">
                              <img src={cur.image ? cur.image : placeholder} alt="event planet" />
                              <div className="info">
                                {currency.symbol}{' '}
                                {currency?.name === 'INR'
                                  ? (Math.floor(cur?.price * currency?.value) || 0).toLocaleString('en-IN')
                                  : Math.floor(cur?.price * currency?.value) || 0}
                              </div>

                              <div className="offtab">
                                <h6>
                                  {" "}
                                  <Link
                                    to={`/dashboard/edit_package/${cur.id}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "white",
                                      fontSize: "11px",
                                      marginLeft: "9px",
                                    }}
                                  >
                                    Edit
                                  </Link>
                                </h6>
                              </div>
                              <div className="offtabdown">
                                <h6>
                                  {" "}
                                  <Link
                                    to={`/dashboard/edit_package/${cur.id}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "white",
                                      fontSize: "11px",
                                      marginLeft: "9px",
                                    }}
                                  >
                                    Edit
                                  </Link>
                                </h6>{" "}
                              </div>
                              <div className="offtabDel">
                                <h6
                                  className="btn btn-sm"
                                  onClick={() => deletePackage(cur.id)}
                                  style={{
                                    color: "white",
                                    fontSize: "11px",
                                    padding: "0px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  Delete
                                </h6>
                              </div>
                              <div className="offtabdownDel">
                                <h6
                                  className="btn btn-sm"
                                  onClick={() => deletePackage(cur.id)}
                                  style={{
                                    color: "white",
                                    fontSize: "11px",
                                    padding: "0px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  Delete
                                </h6>
                              </div>
                              <div className="offtabDelImage">
                                <h6
                                  className="btn btn-sm"
                                  onClick={() => openPriorityModal(cur.id)}
                                  style={{
                                    color: "white",
                                    fontSize: "11px",
                                    padding: "0px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  SetImage
                                </h6>
                              </div>
                              <div className="offtabdownDelImageSet">
                                <h6
                                  className="btn btn-sm"
                                  onClick={() => openPriorityModal(cur.id)}
                                  style={{
                                    color: "white",
                                    fontSize: "11px",
                                    padding: "0px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  SetImage
                                </h6>
                              </div>
                            </div>
                            <div className="card-body package-content-section">
                              <div className="heading_section">
                                <h1 className="package-heading">{cur.package_name}</h1>
                              </div>
                              {cur.city_id && (
                                <div className="heading_section">
                                  <div className="location-section">
                                    <p>
                                      <LocationOnIcon className="custom_icon" />{" "}
                                      {cur?.city_name}
                                    </p>
                                    <span
                                      className={`btn btn-sm status-button ${cur.packagestatus
                                        ? "btn-success"
                                        : "btn-danger"
                                        }`}
                                    >
                                      {cur.packagestatus
                                        ? "Active"
                                        : "Inactive"}
                                    </span>
                                  </div>
                                </div>
                              )}
                              <div className="package_include">
                                {cur.packageincludes
                                  ?.slice(0, 3)
                                  ?.map((item, index) => {
                                    return (
                                      <div className="tab" key={index}>{`${item.label?.length > 8
                                        ? item.label?.slice(0, 8) + "..."
                                        : item.label
                                        }`}</div>
                                    );
                                  })}
                                {cur.packageincludes?.length > 3 && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip">
                                        <ul>
                                          {cur.packageincludes.map(
                                            (item, index) => {
                                              return (
                                                <li key={index}>
                                                  {item.label}
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                      </Tooltip>
                                    }
                                  >
                                    <div className="tab">
                                      +{cur.packageincludes?.length - 3} more
                                    </div>
                                  </OverlayTrigger>
                                )}
                              </div>
                              <div className="other_info">
                                {cur.food_type && (
                                  <div className="custom_tab">
                                    <RamenDiningIcon className="icon" /> &nbsp;
                                    {cur.food_type}
                                  </div>
                                )}
                                {cur.packs && (
                                  <div className="custom_tab">
                                    <PeopleAltIcon className="icon" /> &nbsp;{" "}
                                    {cur.packs} Packs
                                  </div>
                                )}
                                {cur.room && (
                                  <div className="custom_tab">
                                    <MapsHomeWorkIcon className="icon" /> &nbsp;{" "}
                                    {cur.room} Rooms
                                  </div>
                                )}
                                <div className="custom_tab">
                                  <DiscountIcon className="icon" />
                                  {cur.validity}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  {!packageList?.length > 0 && (
                    <p>
                      {language === "en"
                        ? `Create your best package and reach more customers`
                        : `अपना एक बेहतर पैकेज बनाएँ और ज़्यादा से ज़्यादा कस्टमर्स तक पहुँच करें|`}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Select Primary Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex flex-wrap gap-3 justify-content-center">
              {packageImages.length > 0 ? (
                packageImages.map((img) => {
                  const isPrimary = img.is_primary === true;
                  return (
                    <div
                      key={img.id}
                      className="position-relative text-center"
                      style={{
                        border: isPrimary ? "2px solid green" : "1px solid #ccc",
                        borderRadius: "8px",
                        padding: "3px",
                        cursor: "pointer",
                        width: "160px",
                      }}
                    >
                      <img
                        src={img.mobile_image}
                        alt=""
                        style={{
                          width: "150px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />
                      <div className="form-check mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`primary-${img.id}`}
                          checked={isPrimary}
                          onChange={() => handlePriorityChange(img.id)}
                        />
                        <label
                          htmlFor={`primary-${img.id}`}
                          className="form-check-label"
                          style={{ fontSize: "14px" }}
                        >
                          {isPrimary ? "Primary Image" : "Set as Primary"}
                        </label>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No images found for this package.</p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default BundlePackage;